import React, { useEffect, useRef, useState } from 'react';
import styles from './deal.module.css';
import { textStyles } from '../../../constants/textStyles';
import HookForm from '../../../components/HookForm/HookForm';
import SelectClients from '../../../components/Selects/SelectClients';
import SelectDealStatuses from '../../../components/Selects/SelectDealStatuses';
import SelectPaymentTypes from '../../../components/Selects/SelectPaymentTypes';
import Modal from '../../../components/Modal/Modal';
import Cars from '../../Car/Cars';
import DealCreateCarsModal from './DealCreateCarsModal';
import CarFixModal from '../../../components/Modals/CarFixModal';
import getCarMissingFields from '../../../utils/getCarMissingFields';
import SelectCreditPeriod from '../../../components/Selects/SelectCreditPeriod';
import DeleteButton from '../../../components/DeleteButton/DeleteButton';
import formatNumber from '../../../utils/formatNumber';
import ButtonEdit from '../../../components/Button/ButtonEdit';
import axios from 'axios';
import createDeal from '../../../api/deals/createDeal';
import { useLocation, useNavigate } from 'react-router-dom';
import editDeal from '../../../api/deals/editDeal';
import ButtonDelete from '../../../components/Button/ButtonDelete';
import removeItemsToDeal from '../../../api/deals/removeItemsToDeal';
import setStep from '../../../api/deals/setStep';
import addItemsToDeal from '../../../api/deals/addItemsToDeal';
import createNumberMask from '../../../utils/createNumberMask';
import SelectManager from '../../../components/Selects/SelectManager';
import LoaderInline from '../../../components/Loader/LoaderInline';
import { getErrorString } from '@microsoft/signalr/dist/esm/Utils';
import extractErrorMessage from '../../../utils/extractErrorMessage';
import alert from '../../../helpers/alert';
import { useSelector } from 'react-redux';
import { ROLE_MANAGER, ROLE_MOP } from '../../../constants/roles';
import AddButton from '../../../components/AddButton/AddButton';
import ClientCreateModal from '../../../components/ClientCreateModal/ClientCreateModal';
import Select from '../../../components/Select/Select';
import { CAR_ORIGIN_TYPES } from '../../../constants/carOrigin';
import getBuInfo from '../../../api/shop/buInfo';

const DEFAULT_MANAGER_ROLE_IDS = [ROLE_MANAGER, ROLE_MOP];

const DealCreationMainInfo = ({ nextStep, deal, cars, update }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const formRef = useRef(null);
  const [clientModal, setClientModal] = useState(false);

  const [car, setCar] = useState(cars);

  // У б/у авто по договору поручения продавец — клиент, подписавший поручение.
  // Поле информационное: менять его в сделке нельзя, оно определяется автомобилем.
  // Из флоу постановки продавец приезжает вместе с авто, при продаже из карточки —
  // дотягиваем из buInfo.
  const [fetchedSeller, setFetchedSeller] = useState(null);
  const passedSeller = car?.map((item) => item?.consignment?.seller).find(Boolean);
  const consignmentSeller = passedSeller || fetchedSeller;

  // Продавец — такой же клиент из базы, как и покупатель, поэтому и показываем
  // его селектом, только заблокированным: выбирать нечего, он определён авто.
  const sellerOption = consignmentSeller
    ? {
        value: consignmentSeller.id,
        label:
          `${consignmentSeller.surname || ''} ${consignmentSeller.name || ''}`.trim() +
          (consignmentSeller.iin ? ` (ИИН: ${consignmentSeller.iin})` : ''),
      }
    : null;

  useEffect(() => {
    if (passedSeller) return;
    const consignmentCar = car?.find((item) => item?.originCarId === CAR_ORIGIN_TYPES.CONSIGNMENT);
    if (!consignmentCar?.id) {
      setFetchedSeller(null);
      return;
    }
    getBuInfo(consignmentCar.id)
      .then((res) => setFetchedSeller(res?.data?.consignment?.seller || null))
      .catch(() => setFetchedSeller(null));
  }, [car, passedSeller]);

  const inputs = [
    {
      label: 'Клиент',
      name: 'clientId',
      component: SelectClients,
      // Продавец комиссионного авто не может быть в этой же сделке покупателем.
      excludeIds: sellerOption ? [sellerOption.value] : undefined,
      rules: {
        required: !deal,
      },
      defaultValue: deal
        ? { value: deal?.client?.id, label: `${deal?.client?.name} ${deal?.client?.surname}` }
        : location?.state?.client
        ? {
            value: location?.state?.client?.id,
            label: `${location?.state?.client?.name} ${location?.state?.client?.surname}`,
          }
        : null,
    },
    {
      // Клиента можно завести не уходя со сделки — модалка отдаёт готовую опцию,
      // которую сразу подставляем в селект выше.
      name: 'addClient',
      component: AddButton,
      text: 'Добавить клиента',
      onClick: (e) => {
        e.preventDefault();
        setClientModal(true);
      },
    },
    {
      label: 'Способ оплаты',
      name: 'paymentTypeId',
      component: SelectPaymentTypes,
      rules: {
        required: !deal,
      },
      defaultValue: deal ? { value: deal?.paymentType?.id, label: deal?.paymentType?.title } : null,
    },

    {
      label: 'Ответственный менеджер',
      name: 'managerId',
      component: SelectManager,
      rules: {
        required: true,
      },
      defaultValue: DEFAULT_MANAGER_ROLE_IDS.includes(user?.roleId)
        ? {
            value: user?.id,
            label: `${user?.name} ${user?.surname}`,
          }
        : null,
    },

    // {
    //   label: 'Первоначальный взнос',
    //   name: 'initialFee',
    //   dependency: ['paymentTypeId', 'car'],
    //   dependencyAccessor: (obj) => obj[0]?.value,
    //   placeholder: 'Введите первоначальный взнос',
    //   isCredit: true,
    //   hide: () => !car?.length,
    //   mask: createNumberMask({
    //     allowDecimal: true,
    //     prefix: '',
    //     thousandsSeparatorSymbol: ' ',
    //     decimalLimit: 0,
    //   }),
    //   rules: {
    //     valueAsNumber: true,
    //     validate: (value, getValues) => {
    //       value = value?.replace(/\s/g, '');
    //       value = parseInt(value);
    //       if (!car?.length) return true;
    //       const paymentTypeId = getValues('paymentTypeId');
    //       if (paymentTypeId?.value !== 6 && paymentTypeId?.value !== 7) {
    //         return true;
    //       }

    //       let error = true;
    //       const carPrice = car?.reduce((acc, item) => acc + item?.price, 0);
    //       if (value < (carPrice * 0.1)?.toFixed(0)) {
    //         error = `Минимальная сумма взноса 10% от стоимости автомобиля`;
    //       } else if (value > carPrice) {
    //         error = 'Сумма взноса не может превышать стоимость автомобиля';
    //       } else if (isNaN(value)) {
    //         error = 'Поле обязательно для заполнения';
    //       } else {
    //         error = true;
    //       }

    //       return error;
    //     },
    //   },
    // },
    // {
    //   label: 'Срок кредитования, месяцев',
    //   name: 'period',
    //   component: SelectCreditPeriod,
    //   dependency: 'paymentTypeId',
    //   dependencyAccessor: (obj) => obj?.value,
    //   hide: () => !car?.length,
    //   rules: {
    //     deps: ['paymentTypeId', 'car'],
    //     validate: (value, getValues) => {
    //       if (!car?.length) return true;
    //       const paymentTypeId = getValues('paymentTypeId');
    //       let error = true;

    //       if (!value && (paymentTypeId?.value === 6 || paymentTypeId?.value === 7)) {
    //         error = 'Поле обязательно для заполнения';
    //       } else {
    //         error = true;
    //       }

    //       return error;
    //     },
    //   },
    // },
  ];
  const [carsModal, setCarsModal] = useState(false);
  const openCarsModal = () => {
    setCarsModal(true);
  };

  const [fixQueue, setFixQueue] = useState([]);

  const onCarsFormSubmit = (cars) => {
    const currentYear = new Date().getFullYear();
    const problematicCars = cars.filter(car => car.issueYear > currentYear || isNaN(car.issueYear) || car.issueYear < 1900);
    if (problematicCars.length > 0) {
      return alert.error(`Проверьте год выпуска авто ${problematicCars.map(car => `${car.mark} ${car.model} (${car.vin})`).join(', ')}.`);
    }

    // Объём двигателя уходит в банки: они ищут машину в справочнике по марке,
    // модели, году и объёму сразу. Пустой объём ловится ниже как обязательное поле,
    // а неверный виден только по расхождению с комплектацией — предупреждаем здесь,
    // потому что на шаге выбора банков заявка уже уходит и приходит отказ Форте.
    const wrongVolume = cars.filter((car) => car.engineVolumeWarning);
    if (wrongVolume.length > 0) {
      wrongVolume.forEach((car) =>
        alert.error(`${car.mark} ${car.model}: ${car.engineVolumeWarning}`, {
          autoClose: false,
          closeOnClick: false,
        })
      );
    }

    const checked = cars.map((car) => ({ car, missing: getCarMissingFields(car) }));
    const ready = checked.filter((item) => item.missing.length === 0).map((item) => ({ ...item.car, n: true }));
    const incomplete = checked.filter((item) => item.missing.length > 0);

    setCarsModal(false);
    setCar(ready);

    if (incomplete.length > 0) {
      setFixQueue(incomplete);
      alert.error(
        `${incomplete.length > 1 ? 'У некоторых автомобилей' : 'У автомобиля'} не заполнены обязательные поля. Заполните их в открывшемся окне, чтобы добавить ${
          incomplete.length > 1 ? 'их' : 'его'
        } в сделку.`
      );
    }
  };

  const handleCarFixed = (updatedCar) => {
    const missing = getCarMissingFields(updatedCar);
    if (missing.length > 0) {
      setFixQueue((prev) => {
        if (!prev.length) return prev;
        const [, ...rest] = prev;
        return [{ car: updatedCar, missing }, ...rest];
      });
      return;
    }

    setCar((prev) => {
      const existing = prev || [];
      if (existing.some((item) => item.id === updatedCar.id)) return existing;
      return [...existing, { ...updatedCar, n: true }];
    });
    alert.success(`Автомобиль ID${updatedCar?.id} добавлен в сделку`);
    setFixQueue((prev) => prev.slice(1));
  };

  const handleSkipFix = () => {
    const current = fixQueue[0];
    if (current) {
      alert.error(`Автомобиль ID${current.car?.id} не добавлен в сделку — данные не заполнены.`);
    }
    setFixQueue((prev) => prev.slice(1));
  };

  const handleSubmit = (values) => {
    setLoading(true);
    console.log(values);
    const payload = {
      deal: {
        ...values,
        clientId: values?.clientId?.value,
        statusId: values?.statusId?.value,
        paymentTypeId: values?.paymentTypeId?.value,
        managerId: values?.managerId?.value,
      },
      options: {
        cars: car?.map((car) => ({ value: car.id })),
        clientId: values?.clientId?.value,
      },
    };

    // if (values?.paymentTypeId?.value === 6 || values?.paymentTypeId?.value === 7) {
    //   values.initialFee = values?.initialFee?.replace(/\s/g, '');
    //   values.initialFee = parseInt(values?.initialFee);
    //   payload.credit = {
    //     period: Number(values?.period?.value),
    //     initialFee: values?.initialFee,
    //   };
    // }
    if (deal?.id) {
      editDeal({
        clientId: values?.clientId?.value || deal?.client?.id,
        statusId: values?.statusId?.value,
        paymentTypeId: values?.paymentTypeId?.value,
        id: deal?.id,
        dealId: deal?.id,
      })
        .then(() => {
          if (car?.filter((item) => item?.n)?.length) {
            addItemsToDeal({
              cars: car?.map((car) => ({ value: String(car.id) })),
              dealId: String(deal?.id),
              step: 2,
              clientId: values?.clientId?.value || deal?.client?.id,
            })
              .then(() => {
                nextStep();
              })
              .catch((err) => alert(err));
          } else {
            setStep({ dealId: String(deal?.id), step: 2 }).then(() => {
              update();
            });
          }
        })
        .finally(() => setLoading(false));
    } else {
      createDeal(payload)
        .then((res) => {
          nextStep(res?.data);
          navigate(`/deals/deal/${res?.data}/main-info`);
        })
        .catch((err) => {
          alert.error(extractErrorMessage(err?.data) || 'Произошла ошибка при создании сделки');
        })
        .finally(() => setLoading(false));
    }
  };

  const handleCarDelete = (item) => {
    if (item?.n) {
      const newCars = car.filter((car) => car.id !== item.id);
      console.log(newCars);
      setCar(newCars);
    } else {
      removeItemsToDeal({
        cars: [{ value: String(item?.orderId) }],
        dealId: String(deal?.id),
      }).then(() => {
        update();
      });
    }
  };

  useEffect(() => {
    setCar(cars);
  }, [cars]);

  useEffect(() => {
    if (location?.state?.car) {
      onCarsFormSubmit([location?.state?.car]);
    }
  }, [location]);

  const [touched, setTouched] = useState(false);

  // Клиента могли выбрать до того, как в сделку добавили его же авто — из списка
  // он уже отфильтрован, но выбранным остался. Снимаем выбор и говорим почему:
  // молча пропавшее заполненное поле выглядит как баг.
  useEffect(() => {
    if (!sellerOption) return;
    if (formRef.current?.getValues('clientId')?.value !== sellerOption.value) return;
    formRef.current.setValue('clientId', null);
    alert.error('Продавец автомобиля не может быть покупателем в этой же сделке');
  }, [sellerOption?.value]);

  return (
    <>
      {/* <p style={{ ...textStyles.formTitle, marginBottom: 20 }}>Основная информация о сделке</p> */}
      <HookForm
        ref={formRef}
        inputs={inputs}
        title={'Основная информация о сделке'}
        grid={{ display: 'grid', gap: 20 }}
        onSubmit={(values) => {
          if (car?.length) {
            setTouched(false);
            handleSubmit(values);
          } else {
            setTouched(true);
          }
        }}
        action={'Сохранить и продолжить'}
        customData={() =>
          car?.length ? (
            <div style={{ display: 'grid', gap: 20 }}>
              {sellerOption && (
                <Select
                  title="Продавец"
                  hint="Собственник автомобиля по договору поручения. Определяется автомобилем, в сделке не меняется."
                  options={[sellerOption]}
                  value={sellerOption}
                  disabled
                />
              )}
              <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '0 20px', alignItems: 'center' }}>
                <p>Автомобиль:</p>
                {car.map((car) => {
                  return (
                    <div
                      key={car.id}
                      style={{
                        gridColumn: '2/2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      ID{car?.id} {car?.mark} {car?.model} {car?.complectation?.title} {car?.issueYear}{' '}
                      {car?.price ? '(' + formatNumber(car?.price) + ' ₸)' : ''}{' '}
                      <ButtonDelete onClick={() => handleCarDelete(car)} />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null
        }
        addCustomItemTitle="Добавить автомобили"
        handleAddCustomItem={openCarsModal}
        error={car?.length > 0 || !touched ? false : 'Добавьте автомобиль'}
        loading={loading}
      />
      <ClientCreateModal
        isOpen={clientModal}
        onRequestClose={() => setClientModal(false)}
        onCreated={(option) => formRef.current?.setValue('clientId', option)}
      />
      <DealCreateCarsModal
        isOpen={carsModal}
        onRequestClose={() => setCarsModal(false)}
        onSubmit={onCarsFormSubmit}
        onCancel={() => setCarsModal(false)}
      />
      <CarFixModal
        isOpen={fixQueue.length > 0}
        car={fixQueue[0]?.car}
        missingFields={fixQueue[0]?.missing}
        remainingCount={fixQueue.length}
        onFixed={handleCarFixed}
        onSkip={handleSkipFix}
      />
    </>
  );
};

export default DealCreationMainInfo;
